import React from "react";
import "../banner.css";
import { Link } from "react-router-dom";

const Industries = () => {

  const logos = [
    { src: "/img/logo/Bharathi.jpeg", alt: "Bharathi Logo" },
    { src: "/img/logo/chintamani.jpeg", alt: "Chintamani Logo" },
    { src: "/img/logo/gubbaCold.jpg", alt: "Gubba Cold Logo" },
    { src: "/img/logo/Impression.png", alt: "Impression Logo" },
    { src: "/img/logo/murr.png", alt: "Murr Logo" },
    { src: "/img/logo/neotric.jpg", alt: "Neotric Logo" },
    { src: "/img/logo/opel.jpg", alt: "Opel Logo" },
    { src: "/img/logo/tedra.jpg", alt: "Tedra Logo" },
    { src: "/img/logo/ultra.png", alt: "Ultra Logo" },
    { src: "/img/logo/United.jpg", alt: "United Logo" },
    { src: "/img/logo/crysta.png", alt: "crysta Logo" },
    { src: "/img/logo/Rajdeep.png", alt: "Rajdeep Logo" },
    { src: "/img/logo/EZ.png", alt: "EZ Logo", height: 30 },
    { src: "/img/logo/concord.png", alt: "concord Logo" },
  ];

  const rows = [];
  for (let i = 0; i < logos.length; i += 5) {
    rows.push(logos.slice(i, i + 5));
  }

  return (
    <>
      <style>
        {`
          .quote {
            top: 80%;
          }
          .logo-container {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 120px;
            padding: 10px;
          }
          .logo-container img {
            max-width: 100%;
            max-height: 80px;
            object-fit: contain;
          }
        `}
      </style>
      
      <div
        className="container-fluid p-0 banner-section"
        style={{ backgroundImage: "url('/img/about.jpg')" }}
      >
        <div className="overlay"></div>
        <div className="row">
          <div className="col-md-12 mt-5 text-white text-center">
            <h1 className="pt-5 mt-2">INDUSTRIES</h1>
            <nav>
              <ol className="breadcrumb justify-content-center bg-transparent">
                <li className="breadcrumb-item">
                  <Link to="/" className="text-white text-decoration-none">
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  INDUSTRIES
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      
      <div className="container">
        <div className="text-center mb-6 pt-4">
          <p className="fw-bold text-primary fs-4 mb-2">Our Trusted Partners</p>
          <p className="fs-5 px-5">
            Together with our trusted partners, DigiOpen Services creates
            impactful solutions that drive real business growth. Strong
            relationships and mutual trust are at the heart of everything we do.
          </p>
        </div>
      </div>

      <div className="container mb-5">
        {rows.map((row, rowIndex) => (
          <div key={rowIndex} className="row justify-content-center text-center g-3 mb-4">
            {row.map((logo, colIndex) => (
              <div
                key={colIndex}
                className="col-6 col-sm-4 col-md-2 text-center p-2"
              >
                <div className="border border-3 rounded p-3 logo-container h-100">
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    style={logo.height ? { height: logo.height } : {}}
                  />
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
};

export default Industries;